import { wire, api } from "lwc";
import classNames from "classnames";
import { ReflectedElement } from "common/reflectedElement";
import { EffectAdapter } from "common/effectAdapter";
import { attrToBool, BooleanAttr } from "common/helpers";

export default class extends ReflectedElement {
  @api assistiveText: string | null = null;
  @api iconSymbol: string | null = null;
  @api iconSprite: string = "utility";
  @api label: string | null = null;
  @api value: string | null = null;
  @api disabled: BooleanAttr = false;
  @api required: string | null = null;
  @api errorMessage: string | null = null;

  @api
  focus() {
    this.template.querySelector("select")?.focus();
  }

  private get containerClassName() {
    return classNames("select-container", {
      "select-container--icon": this.iconSymbol,
      "select-container--disabled": this.isDisabled,
      "input--errored": this.hasError,
    });
  }

  private get labelText() {
    return this.label || this.assistiveText;
  }

  private get labelClassName() {
    return classNames({
      "tds-helper_field-label": this.label,
      "tds-helper_assistive-text": !this.label && this.assistiveText,
      "label--required": this.isRequired,
    });
  }

  private get selectClassName() {
    return classNames({
      "select--errored": this.hasError,
    });
  }

  private get options() {
    return Array.from(this.contentElement.querySelectorAll("option")).map(
      (n) => n.value
    );
  }

  private handleChange() {
    this.dispatchEvent(
      new CustomEvent("change", {
        detail: this.contentElement.value,
      })
    );
  }

  private get isDisabled() {
    return attrToBool(this.disabled);
  }

  get contentElement(): HTMLSelectElement {
    return this.template.querySelector("select")! as HTMLSelectElement;
  }

  private get isRequired() {
    return attrToBool(this.required);
  }

  private get hasError() {
    return !!this.errorMessage;
  }

  @wire(EffectAdapter, { value: "$value" })
  innerHTMLSetCallback() {
    this.contentElement.value =
      this.value == null ? this.options[0] : this.value;
  }
}
